import React, { useState, useEffect, useRef } from "react";
import Sidebar from "../../component/Sidebar";
import Topbar from "../../component/Topbar";
import { FiPlus, FiUpload, FiTrash, FiSave, FiFileText, FiDollarSign, FiCalendar, FiTag, FiUser, FiHash, FiAlignLeft, FiCreditCard, FiCheckCircle } from "react-icons/fi";
import $ from 'jquery';
import 'jquery-ui/themes/base/all.css';
import 'jquery-ui/ui/widgets/datepicker';
import axios from "axios";
import { baseurl } from "../../baseurl";

/* ─── constants (unchanged) ─── */
const EXPENSE_CATEGORIES = [
  "Utilities","Office Supplies","Rent","Maintenance",
  "Salary","Employee Benefits","Professional Fees","Training",
  "Marketing","Advertising","Public Relations",
  "Travel","Transportation","Logistics/Shipping","Food",
  "Software/SaaS","Hardware",
  "Insurance","Taxes & Licenses","Bank Charges","Other",
];
const PAYMENT_MODES   = ["Cash","UPI","Bank Transfer","Cheque","Card"];
const PAYMENT_STATUS  = ["Paid","Unpaid","Pending","Partially Paid"];

/* ─── CSS ─── */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;600;700;800&family=DM+Sans:wght@400;500;600&display=swap');

:root {
  --ae-teal:      #0a5556;
  --ae-teal-mid:  #0c7172;
  --ae-teal-lite: #14b8a6;
  --ae-gold:      #FFD166;
  --ae-bg:        #eef6f6;
  --ae-white:     #ffffff;
  --ae-border:    rgba(10,85,86,0.10);
  --ae-text:      #0f2a2a;
  --ae-muted:     #5a8080;
  --ae-danger:    #ef4444;
}

@keyframes ae__fadeUp  { from{opacity:0;transform:translateY(16px)} to{opacity:1;transform:translateY(0)} }
@keyframes ae__shimmer { 0%{background-position:-600px 0} 100%{background-position:600px 0} }
@keyframes ae__spin    { to{transform:rotate(360deg)} }
@keyframes ae__pulse   { 0%,100%{box-shadow:0 0 0 0 rgba(10,85,86,0.3)} 70%{box-shadow:0 0 0 7px rgba(10,85,86,0)} }

/* ── page ── */
.ae__wrap {
  font-family:'DM Sans',sans-serif;
  padding:22px 22px 40px;
  background:var(--ae-bg);
  min-height:100vh;
  animation:ae__fadeUp 0.4s ease both;
}

/* ── header ── */
.ae__hd { display:flex; align-items:flex-start; justify-content:space-between; gap:16px; margin-bottom:24px; flex-wrap:wrap; }
.ae__hd-left { display:flex; align-items:center; gap:14px; }
.ae__hd-icon {
  width:48px; height:48px; border-radius:14px; flex-shrink:0;
  background:linear-gradient(135deg,var(--ae-teal),var(--ae-teal-lite));
  display:flex; align-items:center; justify-content:center;
  font-size:20px; color:#fff;
  box-shadow:0 6px 18px rgba(10,85,86,0.26);
}
.ae__hd-title { font-family:'Sora',sans-serif; font-size:20px; font-weight:800; color:var(--ae-text); letter-spacing:-0.03em; margin:0 0 3px; }
.ae__hd-sub   { font-size:12.5px; color:var(--ae-muted); margin:0; }

/* ── layout ── */
.ae__layout { display:grid; grid-template-columns:1fr 340px; gap:20px; align-items:start; }

/* ── card ── */
.ae__card {
  background:var(--ae-white); border-radius:20px;
  border:1px solid var(--ae-border);
  box-shadow:0 2px 20px rgba(10,85,86,0.07),0 8px 40px rgba(0,0,0,0.03);
  overflow:hidden; position:relative;
  margin-bottom:20px;
}
.ae__card:last-child { margin-bottom:0; }
.ae__card::before {
  content:''; position:absolute; top:0; left:0; right:0; height:3px;
  background:linear-gradient(90deg,var(--ae-teal) 0%,var(--ae-teal-lite) 55%,var(--ae-gold) 100%);
}
.ae__sec-hd {
  display:flex; align-items:center; gap:10px;
  padding:16px 22px 12px; border-bottom:1px solid var(--ae-border);
}
.ae__sec-icon {
  width:32px; height:32px; border-radius:10px; flex-shrink:0;
  background:linear-gradient(135deg,var(--ae-teal),var(--ae-teal-lite));
  display:flex; align-items:center; justify-content:center;
  font-size:14px; color:#fff;
  box-shadow:0 4px 10px rgba(10,85,86,0.22);
}
.ae__sec-title { font-family:'Sora',sans-serif; font-size:13px; font-weight:700; color:var(--ae-text); }
.ae__body { padding:20px 22px; }
.ae__body-sm { padding:16px 20px; }

/* ── label ── */
.ae__lbl {
  display:flex; align-items:center; gap:6px;
  font-size:10.5px; font-weight:700; color:var(--ae-text);
  margin-bottom:6px; letter-spacing:0.06em; text-transform:uppercase;
}
.ae__lbl-dot { width:5px; height:5px; border-radius:50%; background:var(--ae-teal); flex-shrink:0; }
.ae__req { color:var(--ae-danger); margin-left:2px; }
.ae__opt { font-size:9px; color:#9ababa; background:rgba(10,85,86,0.06); border:1px solid #c8e4e4; border-radius:50px; padding:1px 7px; margin-left:4px; text-transform:none; letter-spacing:0; }

/* ── inputs ── */
.ae__input, .ae__select, .ae__textarea {
  width:100%; padding:10px 13px;
  font-size:13px; font-family:'DM Sans',sans-serif; color:var(--ae-text);
  background:#f3fafa; border:1.5px solid #c8e4e4; border-radius:11px;
  outline:none; box-sizing:border-box;
  transition:border-color 0.18s, box-shadow 0.18s, background 0.18s;
}
.ae__input:focus,.ae__select:focus,.ae__textarea:focus {
  border-color:var(--ae-teal); background:#fff;
  box-shadow:0 0 0 4px rgba(10,85,86,0.09);
}
.ae__input::placeholder,.ae__textarea::placeholder { color:#9ababa; }
.ae__input[readonly] { background:rgba(10,85,86,0.04); color:var(--ae-muted); cursor:pointer; }
.ae__select {
  appearance:none;
  background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%235a8080' stroke-width='2.5'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
  background-repeat:no-repeat; background-position:right 12px center; padding-right:32px;
  cursor:pointer;
}
.ae__textarea { resize:vertical; min-height:90px; }
.ae__field-wrap { position:relative; }
.ae__field-icon { position:absolute; left:11px; top:50%; transform:translateY(-50%); color:#7aadad; font-size:14px; pointer-events:none; }
.ae__input--icon { padding-left:34px; }
.ae__textarea-icon { position:absolute; left:11px; top:13px; color:#7aadad; font-size:14px; pointer-events:none; }
.ae__textarea--icon { padding-left:34px; }

/* ── grids ── */
.ae__grid2 { display:grid; grid-template-columns:1fr 1fr; gap:14px; }
.ae__field  { display:flex; flex-direction:column; }

/* ── amount display ── */
.ae__amount-preview {
  background:linear-gradient(135deg,var(--ae-teal),var(--ae-teal-mid));
  border-radius:14px; padding:16px 18px; margin-bottom:16px;
  display:flex; flex-direction:column; gap:2px;
}
.ae__amount-lbl  { font-size:11px; font-weight:600; color:rgba(255,255,255,0.65); text-transform:uppercase; letter-spacing:0.07em; }
.ae__amount-val  { font-family:'Sora',sans-serif; font-size:26px; font-weight:800; color:#fff; letter-spacing:-0.02em; }
.ae__amount-tax  { font-size:12px; color:rgba(255,255,255,0.55); margin-top:4px; }

/* ── upload zone ── */
.ae__upload-zone {
  border:2px dashed rgba(10,85,86,0.22); border-radius:14px;
  padding:20px 16px; text-align:center; background:#f9fdfd;
  transition:border-color 0.18s, background 0.18s; cursor:pointer;
  position:relative;
}
.ae__upload-zone:hover { border-color:var(--ae-teal); background:rgba(10,85,86,0.03); }
.ae__upload-icon { color:var(--ae-teal); margin-bottom:8px; font-size:22px; }
.ae__upload-label { font-family:'Sora',sans-serif; font-size:12px; font-weight:700; color:var(--ae-text); margin-bottom:4px; }
.ae__upload-sub   { font-size:11.5px; color:var(--ae-muted); margin-bottom:10px; }
.ae__upload-file-input {
  width:100%; font-size:12px; font-family:'DM Sans',sans-serif;
  background:#f3fafa; border:1.5px solid #c8e4e4; border-radius:9px;
  padding:6px 10px; outline:none; cursor:pointer;
  transition:border-color 0.16s;
}
.ae__upload-file-input:focus { border-color:var(--ae-teal); }
.ae__file-name {
  display:inline-flex; align-items:center; gap:6px; margin-top:8px;
  font-size:11.5px; font-weight:600; color:var(--ae-teal);
  background:rgba(10,85,86,0.07); border-radius:7px; padding:3px 10px;
}

/* ── buttons ── */
.ae__submit-btn {
  width:100%; padding:14px;
  font-size:15px; font-family:'Sora',sans-serif; font-weight:700;
  color:#fff; letter-spacing:0.04em;
  background:linear-gradient(135deg,var(--ae-teal),var(--ae-teal-mid),var(--ae-teal-lite));
  background-size:200% auto;
  border:none; border-radius:13px; cursor:pointer;
  box-shadow:0 6px 24px rgba(10,85,86,0.34);
  transition:background-position 0.4s, transform 0.14s;
  display:flex; align-items:center; justify-content:center; gap:8px;
  position:relative; overflow:hidden; margin-bottom:10px;
}
.ae__submit-btn::after {
  content:''; position:absolute; inset:0;
  background:linear-gradient(90deg,transparent,rgba(255,255,255,0.12),transparent);
  background-size:400px 100%; opacity:0; transition:opacity 0.3s;
}
.ae__submit-btn:hover:not(:disabled) { background-position:right center; transform:translateY(-1px); }
.ae__submit-btn:hover:not(:disabled)::after { opacity:1; animation:ae__shimmer 1.1s linear infinite; }
.ae__submit-btn:disabled { opacity:0.65; cursor:not-allowed; transform:none; }

.ae__spinner {
  width:16px; height:16px; border-radius:50%;
  border:2px solid rgba(255,255,255,0.4); border-top-color:#fff;
  animation:ae__spin 0.7s linear infinite; display:inline-block;
}

.ae__reset-btn {
  width:100%; padding:11px;
  font-size:13.5px; font-family:'Sora',sans-serif; font-weight:700;
  color:var(--ae-muted); background:transparent;
  border:1.5px solid rgba(10,85,86,0.18); border-radius:13px;
  cursor:pointer; display:flex; align-items:center; justify-content:center; gap:7px;
  transition:background 0.16s, color 0.16s, border-color 0.16s;
}
.ae__reset-btn:hover { background:rgba(239,68,68,0.07); color:var(--ae-danger); border-color:rgba(239,68,68,0.22); }

/* ── required note ── */
.ae__req-note { font-size:11.5px; color:var(--ae-muted); margin-top:14px; text-align:center; }

@media(max-width:960px){ .ae__layout{ grid-template-columns:1fr; } }
@media(max-width:600px){ .ae__grid2{ grid-template-columns:1fr; } }
`;

/* ─── Component ─── */
export default function AddExpense() {
  const [expense, setExpense] = useState({
    title:"", category:"", date:"", vendor:"", amount:"",
    taxAmount:"", referenceNo:"", paymentMode:"", paymentStatus:"",
    notes:"", attachment:null,
  });
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("auth_token");
  const dateInputRef = useRef(null);

  /* ── jQuery datepicker (unchanged) ── */
  useEffect(() => {
    $(dateInputRef.current).datepicker({
      dateFormat: "yy-mm-dd",
      onSelect: (dateText) => { updateField("date", dateText); },
    });
    return () => {
      try { $(dateInputRef.current).datepicker("destroy"); } catch (e) { console.log("Datepicker cleanup"); }
    };
  }, []);

  /* ── updaters (unchanged) ── */
  const updateField     = (key, value) => setExpense(prev => ({ ...prev, [key]: value }));
  const handleFileUpload = (e)          => updateField("attachment", e.target.files[0]);

  /* ── submit (unchanged) ── */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();
    formData.append("title",         expense.title);
    formData.append("category",      expense.category);
    formData.append("date",          expense.date);
    formData.append("vendor",        expense.vendor || "");
    formData.append("amount",        expense.amount);
    formData.append("taxAmount",     expense.taxAmount || "0");
    formData.append("referenceNo",   expense.referenceNo || "");
    formData.append("paymentMode",   expense.paymentMode);
    formData.append("paymentStatus", expense.paymentStatus);
    formData.append("notes",         expense.notes || "");
    if (expense.attachment) formData.append("attachment", expense.attachment);

    console.log("--- DATA BEING SENT TO BACKEND ---");
    const dataForLog = {};
    formData.forEach((value, key) => { dataForLog[key] = value instanceof File ? `File: ${value.name}` : value; });
    console.table(dataForLog);

    try {
      const response = await axios.post(`${baseurl}createExpense`, formData, {
        headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${token}` },
      });
      console.log("--- BACKEND SUCCESS RESPONSE ---");
      console.log(response.data);
      alert("Expense added successfully!");
      resetForm();
    } catch (error) {
      console.error("--- BACKEND ERROR RESPONSE ---");
      console.error(error.response?.data || error.message);
      alert("Failed to add expense. Check console for details.");
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => setExpense({
    title:"", category:"", date:"", vendor:"", amount:"",
    taxAmount:"", referenceNo:"", paymentMode:"", paymentStatus:"", notes:"", attachment:null,
  });

  /* ═══ RENDER ═══ */
  return (
    <>
      <style>{CSS}</style>
      <Topbar />
      <Sidebar />
      <main className="main-wrapper">
        <div className="ae__wrap">

          {/* ── Header ── */}
          <div className="ae__hd">
            <div className="ae__hd-left">
              <div className="ae__hd-icon"><FiPlus /></div>
              <div>
                <div className="ae__hd-title">Create New Expense</div>
                <div className="ae__hd-sub">Manage and track your business expenditures</div>
              </div>
            </div>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="ae__layout">

              {/* ══ LEFT COLUMN ══ */}
              <div>

                {/* General Info */}
                <div className="ae__card">
                  <div className="ae__sec-hd">
                    <div className="ae__sec-icon"><FiFileText size={14} /></div>
                    <div className="ae__sec-title">General Information</div>
                  </div>
                  <div className="ae__body">

                    {/* Title */}
                    <div className="ae__field" style={{ marginBottom:14 }}>
                      <div className="ae__lbl"><div className="ae__lbl-dot" />Expense Title<span className="ae__req">*</span></div>
                      <div className="ae__field-wrap">
                        <FiFileText className="ae__field-icon" />
                        <input type="text" className="ae__input ae__input--icon"
                          placeholder="e.g. Monthly Office Rent"
                          value={expense.title}
                          onChange={(e) => updateField("title", e.target.value)}
                          required />
                      </div>
                    </div>

                    <div className="ae__grid2" style={{ marginBottom:14 }}>
                      {/* Category */}
                      <div className="ae__field">
                        <div className="ae__lbl"><div className="ae__lbl-dot" />Category<span className="ae__req">*</span></div>
                        <div className="ae__field-wrap">
                          <FiTag className="ae__field-icon" />
                          <select className="ae__select ae__input--icon"
                            value={expense.category}
                            onChange={(e) => updateField("category", e.target.value)}
                            required>
                            <option value="">Choose category…</option>
                            {EXPENSE_CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
                          </select>
                        </div>
                      </div>

                      {/* Date */}
                      <div className="ae__field">
                        <div className="ae__lbl"><div className="ae__lbl-dot" />Expense Date<span className="ae__req">*</span></div>
                        <div className="ae__field-wrap">
                          <FiCalendar className="ae__field-icon" />
                          <input type="text" ref={dateInputRef} className="ae__input ae__input--icon"
                            placeholder="YYYY-MM-DD"
                            value={expense.date}
                            readOnly required />
                        </div>
                      </div>
                    </div>

                    <div className="ae__grid2">
                      {/* Vendor */}
                      <div className="ae__field">
                        <div className="ae__lbl"><div className="ae__lbl-dot" />Vendor / Merchant<span className="ae__opt">Optional</span></div>
                        <div className="ae__field-wrap">
                          <FiUser className="ae__field-icon" />
                          <input type="text" className="ae__input ae__input--icon"
                            placeholder="Company Name"
                            value={expense.vendor}
                            onChange={(e) => updateField("vendor", e.target.value)} />
                        </div>
                      </div>

                      {/* Reference */}
                      <div className="ae__field">
                        <div className="ae__lbl"><div className="ae__lbl-dot" />Reference / Invoice #<span className="ae__opt">Optional</span></div>
                        <div className="ae__field-wrap">
                          <FiHash className="ae__field-icon" />
                          <input type="text" className="ae__input ae__input--icon"
                            placeholder="REF-00123"
                            value={expense.referenceNo}
                            onChange={(e) => updateField("referenceNo", e.target.value)} />
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

                {/* Notes */}
                <div className="ae__card">
                  <div className="ae__sec-hd">
                    <div className="ae__sec-icon"><FiAlignLeft size={14} /></div>
                    <div className="ae__sec-title">Notes &amp; Description</div>
                  </div>
                  <div className="ae__body">
                    <div className="ae__field">
                      <div className="ae__lbl"><div className="ae__lbl-dot" />Additional Notes<span className="ae__opt">Optional</span></div>
                      <div className="ae__field-wrap">
                        <FiAlignLeft className="ae__textarea-icon" />
                        <textarea className="ae__textarea ae__textarea--icon" rows="3"
                          placeholder="Enter specific details, terms, or remarks…"
                          value={expense.notes}
                          onChange={(e) => updateField("notes", e.target.value)} />
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              {/* ══ RIGHT COLUMN ══ */}
              <div>

                {/* Financials */}
                <div className="ae__card">
                  <div className="ae__sec-hd">
                    <div className="ae__sec-icon"><FiDollarSign size={14} /></div>
                    <div className="ae__sec-title">Financials</div>
                  </div>
                  <div className="ae__body-sm">

                    {/* Amount preview */}
                    <div className="ae__amount-preview">
                      <div className="ae__amount-lbl">Total Amount</div>
                      <div className="ae__amount-val">
                        {expense.amount ? `₹ ${Number(expense.amount).toLocaleString("en-IN")}` : "₹ 0"}
                      </div>
                      {expense.taxAmount && (
                        <div className="ae__amount-tax">Tax Component: ₹ {Number(expense.taxAmount).toLocaleString("en-IN")}</div>
                      )}
                    </div>

                    <div className="ae__field" style={{ marginBottom:12 }}>
                      <div className="ae__lbl"><div className="ae__lbl-dot" />Total Amount (₹)<span className="ae__req">*</span></div>
                      <div className="ae__field-wrap">
                        <FiDollarSign className="ae__field-icon" />
                        <input type="number" className="ae__input ae__input--icon"
                          placeholder="0.00"
                          value={expense.amount}
                          onChange={(e) => updateField("amount", e.target.value)}
                          required />
                      </div>
                    </div>

                    <div className="ae__field" style={{ marginBottom:12 }}>
                      <div className="ae__lbl"><div className="ae__lbl-dot" />Tax Component<span className="ae__opt">Optional</span></div>
                      <div className="ae__field-wrap">
                        <FiTag className="ae__field-icon" />
                        <input type="number" className="ae__input ae__input--icon"
                          placeholder="0.00"
                          value={expense.taxAmount}
                          onChange={(e) => updateField("taxAmount", e.target.value)} />
                      </div>
                    </div>

                    <div className="ae__field" style={{ marginBottom:12 }}>
                      <div className="ae__lbl"><div className="ae__lbl-dot" />Payment Method<span className="ae__req">*</span></div>
                      <div className="ae__field-wrap">
                        <FiCreditCard className="ae__field-icon" />
                        <select className="ae__select ae__input--icon"
                          value={expense.paymentMode}
                          onChange={(e) => updateField("paymentMode", e.target.value)}
                          required>
                          <option value="">Select Method</option>
                          {PAYMENT_MODES.map(m => <option key={m} value={m}>{m}</option>)}
                        </select>
                      </div>
                    </div>

                    <div className="ae__field">
                      <div className="ae__lbl"><div className="ae__lbl-dot" />Payment Status<span className="ae__req">*</span></div>
                      <div className="ae__field-wrap">
                        <FiCheckCircle className="ae__field-icon" />
                        <select className="ae__select ae__input--icon"
                          value={expense.paymentStatus}
                          onChange={(e) => updateField("paymentStatus", e.target.value)}
                          required>
                          <option value="">Select Status</option>
                          {PAYMENT_STATUS.map(s => <option key={s} value={s}>{s}</option>)}
                        </select>
                      </div>
                    </div>

                  </div>
                </div>

                {/* Receipt Upload */}
                <div className="ae__card" style={{ marginBottom:16 }}>
                  <div className="ae__sec-hd">
                    <div className="ae__sec-icon"><FiUpload size={14} /></div>
                    <div className="ae__sec-title">Receipt Upload</div>
                  </div>
                  <div className="ae__body-sm">
                    <div className="ae__upload-zone">
                      <div className="ae__upload-icon"><FiUpload /></div>
                      <div className="ae__upload-label">Attach Receipt or Invoice</div>
                      <div className="ae__upload-sub">PDF, JPG, PNG supported</div>
                      <input type="file" className="ae__upload-file-input" onChange={handleFileUpload} />
                    </div>
                    {expense.attachment && (
                      <div style={{ marginTop:8, textAlign:"center" }}>
                        <span className="ae__file-name"><FiFileText size={12} />{expense.attachment.name}</span>
                      </div>
                    )}
                  </div>
                </div>

                {/* Action Buttons */}
                <button type="submit" className="ae__submit-btn" disabled={loading}>
                  {loading
                    ? <><div className="ae__spinner" /> Processing…</>
                    : <><FiSave size={15} /> Complete Entry</>}
                </button>
                <button type="button" className="ae__reset-btn" onClick={resetForm}>
                  <FiTrash size={13} /> Reset Form
                </button>
                <div className="ae__req-note">Fields marked with <span style={{ color:"var(--ae-danger)" }}>*</span> are required</div>

              </div>

            </div>
          </form>

        </div>
      </main>
    </>
  );
}
